module.exports = __webpack_public_path__ + "static/media/icon-sign.6dc5dceb.svg";